<template>
    <div class="Hazardous-selector-container">
      <RCSelect
        :suggestions="HazardousOptions"
        v-model="selectedHazardousOption"
        label="Select Hazmat"
        @change="handleHazardousSelection"
        :class="{'input-error': isHazardousSelected && !selectedHazardousOption}"
        class="Hazardous-selector"
      />
    </div>
  </template>

<script>
import RCSelect from "@/components/RCComponents/CustomRCSelect.vue";
import { HazardousOptions } from "@/utils/DrayageDetails";

export default {
  name: "HazardousSelector",
  components: {
    RCSelect,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    isHazardousSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedHazardousOption: this.value,
      HazardousOptions,
    };
  },
  watch: {
    selectedHazardousOption(newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    handleHazardousSelection(option) {
      this.$emit("change", option);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
.Hazardous-selector-container {
  margin-left: 10px;
  width: 150px;
}
.input-error ::v-deep .rc-select-container {
background: $missing-fields;
}

</style>
